import { instanceOf, oneOfType } from 'prop-types'

import MountPointsClass from 'shared/utils/mountPoints'

export const mountPointsType = oneOfType([instanceOf(MountPointsClass)])
